import {isNotNil} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {localeToLanguage} from './localeToLanguage';

/**
 * Picks the content language whose title extension the backend publishes and whose value the
 * general `title_extension` attribute mirrors. Same rule as the backend
 * `TenantDefaultLanguageResolver`: the tenant locale language when it is enabled, otherwise the
 * first enabled language.
 */
export function resolveDefaultContentLanguage(
  tenantDefaultLocale: string | Nullish,
  enabledLanguages: string[]
): string | null {
  const localeLanguage = localeToLanguage(tenantDefaultLocale);

  if (isNotNil(localeLanguage) && enabledLanguages.includes(localeLanguage)) {
    return localeLanguage;
  }

  return enabledLanguages[0] ?? null;
}
